module.exports = __webpack_public_path__ + "static/media/help-icon-2.1ef27626.svg";